import React, { useState } from "react";

// import { useHistory } from "react-router-dom";

import Banner from "./Banner.jsx";
import { useContext } from "react";
import { ContextProvider } from "../../App";

import Header from "../../common/Header.jsx";
import Footer from "../../common/Footer.jsx";

import MonthlyMenu from "./monthly/MonthlyMenu.jsx";
import DailyMenu from "./daily/DailyMenu.jsx";

import AuthorizedHeader from "../../common/authorized/AuthorizedHeader.jsx";

function OrderIndex() {
  const { cartDispatch, isMobile, authState } =
    useContext(ContextProvider);
  

  const [selectionPlan, setSelectionPlan] = useState("monthly");
  const [mondayItem, setMondayItem] = useState("");
  const [tuesItem, setTuesItem] = useState("");
  const [wednesdayItem, setWednesdayItem] = useState("");
  const [thursdayItem, setThursdayItem] = useState("");
  const [fridayItem, setFridayItem] = useState("");


  const handleSelectionMenuPlan = (pkgName) => {
    setMondayItem("")
    setTuesItem("")
    setWednesdayItem("")
    setThursdayItem("")
    setFridayItem("")

    cartDispatch({ type:"SELECT_SUBSCRIPTION", pkgName})
    if (pkgName === "daily") {
      setSelectionPlan("daily");
    } else if (pkgName === "weekly") {
      setSelectionPlan("weekly");
    } else {
      setSelectionPlan("monthly");
    }
  };

  return (
    <>
      {authState.loggedIn === true ? <AuthorizedHeader /> : <Header />}
      <div
        className="category_container"
        style={{ backgroundColor: "#F9F9F9" }}
      >
        <div>
          <Banner
            handleSelectionMenuPlan={handleSelectionMenuPlan}
            selectionPlan={selectionPlan}
          />
          {selectionPlan === "daily" ? (
            <>
              <DailyMenu selectionPlan={selectionPlan} />
            </>
          ) : (
            <>
              <MonthlyMenu
                  selectionPlan={selectionPlan}
                  mondayItem={mondayItem}
                  setMondayItem={setMondayItem}
                  
                  tuesItem={tuesItem}
                  setTuesItem={setTuesItem}

                  wednesdayItem={wednesdayItem}
                  setWednesdayItem={setWednesdayItem}

                  thursdayItem={thursdayItem}
                  setThursdayItem={setThursdayItem}

                  fridayItem={fridayItem}
                  setFridayItem={setFridayItem}
              />
            </>
          )}
        </div>
      </div>
      <div>
        <Footer footerWidth={isMobile ? "100%" : "76%"} />
      </div>
    </>
  );
}

export default OrderIndex;
